import { createContext } from 'react';
import type { Locale } from '@/i18n';

export interface I18nContextType {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: string, variables?: Record<string, string | number>) => string;
  localeNames: Record<Locale, string>;
}

export const I18nContext = createContext<I18nContextType | null>(null);
